class ProductImageUpload extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;
    this.dataset.initialized = 'true';

    this.input = this.querySelector('[data-product-image-upload]');
    this.dropZone = this.querySelector('[data-image-drop-zone]');
    this.status = this.querySelector('[data-image-upload-status]');
    this.dragDepth = 0;

    if (!this.input || !this.dropZone || !this.status) return;

    this.dropZone.addEventListener('click', () => this.input.click());
    this.input.addEventListener('change', () => this.updateStatus());
    this.dropZone.addEventListener('dragenter', (event) => this.handleDragEnter(event));
    this.dropZone.addEventListener('dragover', (event) => event.preventDefault());
    this.dropZone.addEventListener('dragleave', (event) => this.handleDragLeave(event));
    this.dropZone.addEventListener('drop', (event) => this.handleDrop(event));

    this.updateStatus();
  }

  handleDragEnter(event) {
    event.preventDefault();
    this.dragDepth += 1;
    this.dropZone.classList.add('is-dragging');
  }

  handleDragLeave(event) {
    event.preventDefault();
    this.dragDepth = Math.max(0, this.dragDepth - 1);
    if (this.dragDepth === 0) this.dropZone.classList.remove('is-dragging');
  }

  handleDrop(event) {
    event.preventDefault();
    this.dragDepth = 0;
    this.dropZone.classList.remove('is-dragging');

    if (!event.dataTransfer?.files.length) return;

    this.input.files = event.dataTransfer.files;
    this.input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  updateStatus() {
    const files = Array.from(this.input.files ?? []);
    const hasUnsupportedFile = files.some((file) => !file.type.startsWith('image/'));
    let errorMessage = '';

    if (files.length > 3) {
      errorMessage = 'Please select no more than 3 images.';
    } else if (hasUnsupportedFile) {
      errorMessage = 'Please select image files only.';
    }

    this.input.setCustomValidity(errorMessage);
    this.dropZone.toggleAttribute('aria-invalid', Boolean(errorMessage));

    if (errorMessage) {
      this.status.textContent = files.length > 3 ? 'Maximum 3 files' : 'Images only';
    } else if (files.length === 1) {
      this.status.textContent = '1 file';
    } else if (files.length > 1) {
      this.status.textContent = `${files.length} files`;
    } else {
      this.status.textContent = 'Add file';
    }
  }
}

if (!customElements.get('product-image-upload')) {
  customElements.define('product-image-upload', ProductImageUpload);
}
